import { takeEvery } from 'typed-redux-saga';
import { actionLoosingWeightLoadData } from './actions';
import { workerErrorNotifyThunk } from 'utils/sagas';

export const loosingWeightSagas = [
  takeEvery(actionLoosingWeightLoadData.rejected, workerErrorNotifyThunk),
];
